import React, { Component } from "react";
import "./style.css";
class SchoolConditionView extends Component {
  render() {
    const { condition } = this.props;
    return <div className="schoolConditionView_box">当前选科：{condition}</div>;
  }
}

export default SchoolConditionView;



// WEBPACK FOOTER //
// ./src/components/School/SchoolDetail/SchoolConditionView/index.js